import { DataSourceSetupComposite } from "./DataSourceSetupComposite";
import { Checkbox, Flex, TextArea } from "@theorgchartdev/storybook";
import {
  DATA_SOURCES_TEST_PREFIX,
  kKeyToLabelAndDefaultText
} from "@/appComponents/Blocks/Modals/SettingsModal/ChartSettings/DataSourceConfiguration/Utils";
import { BambooOIDCSetup } from "./BambooOIDCSetup";
import { appstr } from "@coreapp/utils/appstr";
import { kBambooHeaders } from "@coreapp/constants";
import { appcstr } from "@coreapp/utils/appcstr";

const BuildInputs = isLegacy => {
  const keys = isLegacy ? ["subdomain", "apiKey"] : ["subdomain"];
  const inputOptions = [];
  for (let key of keys) {
    const legacyOption = {};
    legacyOption.dataKey = key;
    legacyOption.label = appcstr(kKeyToLabelAndDefaultText[key][0]);
    legacyOption.placeholder = appcstr(kKeyToLabelAndDefaultText[key][1]);
    legacyOption.passwordMask = key === "apiKey";
    inputOptions.push(legacyOption);
  }
  return inputOptions;
};

export const BambooHRSetupComposite = ({ config, onChange, index, importType, chartConfig }) => {
  const bambooAdditionalFields = kBambooHeaders.map(bambooHeader => {
    return {
      value: { headerName: bambooHeader.alias, headerLabel: bambooHeader.name },
      label: bambooHeader.name
    };
  });

  const customFields = config["CustomADPFields"] ?? [];
  const customAdditionalFields = customFields.map(customField => {
    return {
      value: { headerName: customField.name, headerId: customField.id },
      label: customField.name
    };
  });

  const additionalFieldOptions = bambooAdditionalFields.concat(customAdditionalFields);

  const selectedAdditionalFields = config.customheaders ?? [];

  const { terminated, doCustomTable, table, isLegacy } = config;

  // Use custom input options when legacy mode enabled
  const customInputOptions = BuildInputs(isLegacy);

  const onAdditionalFieldToggle = e => {
    let option = e.value;
    let newHeader = option?.value;
    if (!newHeader) return;
    let customHeaders = config.customheaders ?? [];
    var currentIndex = customHeaders.findIndex(
      sourceItem => JSON.stringify(sourceItem) === JSON.stringify(newHeader)
    );
    if (currentIndex > -1) customHeaders.splice(currentIndex, 1);
    else customHeaders.push(newHeader);
    onChange({ ...config, customheaders: customHeaders });
  };

  const handleChange = (key, value) => {
    onChange({ ...config, [key]: value });
  };

  const AuthNode = <BambooOIDCSetup value={config} onChange={handleChange} />;

  return (
    <DataSourceSetupComposite
      config={config}
      onChange={onChange}
      index={index}
      chartConfig={chartConfig}
      additionalFieldOptions={additionalFieldOptions}
      selectedAdditionalFields={selectedAdditionalFields}
      onAdditionalFieldChange={onAdditionalFieldToggle}
      showInputControls
      showAdditionalFields
      showConfiguration={importType !== "import"}
      showLoadHeaders={importType !== "import"}
      importType={importType}
      doInputLookup={false}
      inputOptions={customInputOptions}
      postInputControlsNode={AuthNode}
    >
      <Flex direction={"column"} gap={"8px"}>
        <Checkbox
          id={"include-terminated"}
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-bamboohr-include-terminated-checkbox`}
          label={appstr("Include terminated employees")}
          size={"medium"}
          checked={terminated}
          onChange={() => onChange({ ...config, terminated: !terminated })}
        />
        <Flex direction={"column"} gap={"4px"}>
          <Checkbox
            id={"use-table"}
            data-testid={`${DATA_SOURCES_TEST_PREFIX}-bamboohr-use-table-checkbox`}
            label={appstr("Use Table")}
            size={"medium"}
            checked={doCustomTable}
            onChange={() => {
              onChange({ ...config, doCustomTable: !doCustomTable });
            }}
          />
          {doCustomTable && (
            <TextArea
              dataTestId={`${DATA_SOURCES_TEST_PREFIX}-bamboohr-custom-table-textarea`}
              inputOnly
              size="medium"
              value={table}
              placeholder={appstr("Table")}
              onChange={event => onChange({ ...config, table: event.target.value })}
            />
          )}
        </Flex>
        <Checkbox
          id={"is-legacy"}
          data-testid={`${DATA_SOURCES_TEST_PREFIX}-bamboohr-legacy-api-key-checkbox`}
          label={appstr("Use (Legacy) API Key")}
          size={"medium"}
          checked={isLegacy}
          onChange={() => {
            onChange({ ...config, isLegacy: !isLegacy });
          }}
        />
      </Flex>
    </DataSourceSetupComposite>
  );
};
